import { useContext, useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { gql } from 'graphql-request';

import { AppContext } from '../../App.context';

export function useAuth(password: string): AuthResponse {
	const { graphQLClient, parseGraphQLClientError } = useContext(AppContext);
	const [token, setToken] = useState('');
	const [expiredAt, setExpiredAt] = useState('');
	const cacheTime = 0;
	const { data, isPending, error } = useQuery<AuthenticateQuery>({
		queryKey: ['authenticate'],
		queryFn: async () =>
			graphQLClient.request(authenticateAdminQueryDocument, {
				password,
			}),
		enabled: !!password,
		staleTime: cacheTime,

		gcTime: cacheTime,
	});

	useEffect(() => {
		if (!data) return;
		if (!data.authenticateAdmin) return;
		const { authenticateAdmin } = data;

		setToken(authenticateAdmin.token);
		setExpiredAt(authenticateAdmin.expiredAt);
	}, [data]);

	return {
		token,
		expiredAt,
		isLoading: password ? isPending : false,
		error: error ? parseGraphQLClientError(error) : null,
	};
}

interface AuthenticateQuery {
	authenticateAdmin: {
		token: string;
		expiredAt: string;
	};
}

interface AuthResponse {
	token: string;
	expiredAt: string;
	isLoading: boolean;
	error: Error | null;
}

export const authenticateAdminQueryDocument = gql`
	query AuthenticateAdmin($password: String!) {
		authenticateAdmin(password: $password) {
			token
			expiredAt
		}
	}
`;
